import MlChat from "@/components/MlChat";
export default {
  components: {
    MlChat: MlChat
  },
  computed: {
    botao: function botao() {
      var botao = {
        'cor': '#3303FF',
        'icone': 'mdi-help-circle-outline'
      };
      if (this.$store.state.chat.mensagens > 0) {
        botao = {
          'cor': '#4CAF50',
          'icone': 'mdi-message-text-outline'
        };
      }
      return botao;
    }
  }
};